module.exports = __webpack_public_path__ + "static/media/Foto_AT__Rubrik_About.8916eb86.jpg";